import { Trans } from "react-i18next";

export default function AiIdeaFeedbackContent({ ownerIdea, status }) {
  return (
    <Trans
      i18nKey={
        status === "success" ? "notifications.aiIdeaFeedbackSuccess"
        : status === "pending" ?
          "notifications.aiIdeaFeedback"
        : "notifications.aiIdeaFeedbackFailed"
      }
      values={{ idea: ownerIdea?.name || "Deleted" }}
    />
  );
}
